import { Avatar, Descriptions, Modal, Spin, Tooltip } from "antd";
import {
  capitalize,
  capitalizeFirstLetter,
  formatPath,
  formatMoney,
  getInitials,
  getRandomColor,
  previewPaper,
} from "../../../utils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import eyeSvg from "../../../assets/svg/eye.svg";
import { downloadPost, save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";

export default function FundsTransferInfoModal({
  open,
  handleOkay,
  selectedItem,
  reimbursement,
}) {
  const wallets = [];
  const otherItems = [];
  const accWallet = [];
  const isLoading = false;
  const data = [];
  const { approvalInfo } = useSelector((state) => state.fetch);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();
  const [previewUrl, setPreviewUrl] = useState(null);

  const handlePreview = async () => {
    const res = await dispatch(
      downloadPost({
        procAprvId: selectedItem?.procAprvId,
        url: `api/v1/approvals/preview-process-approval-pdf`,
      }),
    );
    if (res?.payload) {
      const blobData = res.payload.data;
      const headers = res.payload.headers;
      const contentType = headers["content-type"] || "application/pdf";
      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      setPreviewUrl(url);
    } else {
      toast.error("Failed to preview invoice");
    }
  };
  const handleClosePreview = () => {
    if (previewUrl) {
      window.URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl(null);
  };

  const items = [
    {
      key: "1",
      label: "Source account",
      children: wallets.isLoading ? (
        <Spin className="blu_spin text-left mt-[1.25remrem]" />
      ) : (
        <span>
          {capitalize(approvalInfo?.sourceAccount)} |{" "}
          {formatMoney(approvalInfo?.wtdAmount)}
        </span>
      ),
    },
    {
      key: "2",
      label: "Recipient",
      children: (() => {
        const isBulk = approvalInfo?.entryType === "BULK";

        return (
          <div className="flex items-center gap-5">
            <div
              className={isBulk ? "cursor-pointer underline" : ""}
              onClick={
                isBulk ? () => previewPaper(approvalInfo?.recipient) : undefined
              }
            >
              {formatPath(approvalInfo?.recipient)}
            </div>

            {isBulk && (
              <Tooltip title="Preview">
                {saving ? (
                  <Spin className="sms-spin" />
                ) : (
                  <img
                    disabled={saving}
                    onClick={handlePreview}
                    src={eyeSvg}
                    alt="eyeSvg"
                    className="cursor-pointer"
                  />
                )}
              </Tooltip>
            )}
          </div>
        );
      })(),
    },
    {
      key: "3",
      label: "Amount",
      children: formatMoney(approvalInfo?.amount, "KES"),
    },
    {
      key: "4",
      label: "Transfer reason",
      children: <span>{capitalizeFirstLetter(approvalInfo?.reason)}</span>,
    },
  ];

  useEffect(() => {}, [wallets.data, selectedItem]);

  return (
    <>
      <Modal
        centered
        className="modal-btn mod-height mod-footer"
        title={"Review request"}
        open={open}
        width={500}
        footer={false}
        onCancel={handleOkay}
      >
        <div className="px-[2.94rem] pt-[.19rem] w-full h-full">
          <div className="w-full flex flex-col">
            <div className="grid grid-cols-1 gap-[.94rem]">
              <span className="label_1 mt-[1.25rem]">
                {selectedItem?.procAprvIntiatorUsrName} has made the following
                request{" "}
              </span>

              <div className="w-full">
                <Descriptions
                  title={false}
                  items={items}
                  column={1}
                  colon={false}
                  size="small"
                />
              </div>

              {reimbursement && otherItems.isLoading ? (
                <Spin className="blu_spin text-left mt-[1.25remrem]" />
              ) : reimbursement &&
                !otherItems.isLoading &&
                otherItems?.data?.length ? (
                <>
                  <span className="label_1 mt-[1.25rem] underline">
                    Items:{" "}
                  </span>
                  {otherItems?.data?.map((item, index) => {
                    return (
                      <div key={index}>
                        <div className="flex items-center gap-[.25rem]">
                          <span className="label_2 flex min-w-[5rem] w-auto">
                            {item?.wtdName}|{" "}
                          </span>
                          <span className="paragraph_1">
                            {formatMoney(item?.wtdAmount, "KES")}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : null}

              {isLoading ? (
                <Spin className="blu_spin text-left mt-[1.25remrem]" />
              ) : !isLoading && approvalInfo?.reviewers?.length ? (
                <>
                  <span className="label_1 mt-[1.25rem]">
                    The following signitories have already approved{" "}
                  </span>
                  {approvalInfo?.reviewers?.map((item, index) => {
                    return (
                      <div key={index} className="mt-[.5rem]">
                        <div className="flex items-center gap-[.25rem]">
                          <Avatar
                            style={{
                              backgroundColor: `#${getRandomColor()}`,
                            }}
                          >
                            {getInitials(item?.procAprvUsrName)}
                          </Avatar>
                          <span>{item?.procAprvUsrName}</span>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : null}
            </div>

            <div className="flex items-center justify-center my-[3rem] w-full">
              <div className="w-[12.4375rem] flex items-center gap-[.5rem]">
                <button
                  onClick={handleOkay}
                  className="cstm-btn-2"
                  type="button"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title="Payments Preview"
        open={!!previewUrl}
        onCancel={handleClosePreview}
        footer={null}
        width="60vw"
        style={{ top: 20 }}
        destroyOnClose
      >
        {previewUrl && (
          <iframe
            src={previewUrl}
            title="Payments Preview"
            style={{ width: "100%", height: "80vh", border: "none" }}
          />
        )}
      </Modal>
    </>
  );
}
